import React, { FC, memo, useMemo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { ISimilarProfBlockProps } from '../types'
import { ProfessionsList } from '../../../../../../components/ProfessionsList/desktop'

const Block = styled.div``

/* Похожие профессии */
const SimilarProfBlock: FC<ISimilarProfBlockProps> = (props) => {
  const { items } = props

  const professions = useMemo(() => {
    if (items) {
      return items.map((item) => {
        return {
          id: item.id,
          name: item.name,
          description: item.shortDescription,
          vuzCount: item?.stats?.universitiesCount,
          collageCount: item?.stats?.collegesCount,
        }
      })
    }

    return []
  }, [items])

  return (
    <Block>
      <Heading h2='Похожие профессии ' spacing='large' />

      <ProfessionsList items={professions} />
    </Block>
  )
}

export default memo(SimilarProfBlock)
